import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Project from './views/Project.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/p/:project_slug',
      name: 'project',
      component: Project
    },
    {
      path: '/f/:factsheet_id',
      name: 'factsheet',
      component: () => import('./views/factsheet/Factsheet.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/frequently-asked-questions',
      name: 'faqs',
      component: () => import('./views/FAQs.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/login/ldr',
      name: 'login-ldr',
      component: () => import('./views/LoginLdr.vue')
    },
    {
      path: '/idh',
      name: 'home-idh',
      component: () => import('./views/LoginLdr.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/Logout.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue')
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('./views/Terms.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue')
    },
    {
      path: '/example',
      name: 'example',
      redirect: '/f/540910687'
    },
    {
      path: '/location/:factsheet_uuid/factsheet/basic',
      name: 'legacy',
      component: () => import('./views/Legacy.vue')
    }

    // ,
    // {
    //   path: '/test',
    //   name: 'test',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
  ,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }    
    } else {
      return { 
        x: 0, 
        y: 0
      }
    }
  }
})
